import React from 'react'
import { Link } from 'gatsby'

import { breakpoints } from 'src/ui/dimensions'
import { styled, useTheme } from 'src/ui/theme'
import { HBox, Wrapper } from 'src/ui/layout'
import { Image } from 'src/ui/atoms'
import { Header, Body } from 'src/ui/typography'

import VisibilitySensor from 'react-visibility-sensor'
import { useSpring, animated } from 'react-spring'

const Title = styled.div`
  opacity: 0;
  position: absolute;

  right: 64px;
  bottom: 64px;
  max-width: 488px;
  padding: 0 16px;
  z-index: 2;
  text-align: right;
`

const Container = styled.div`
  padding: 64px 0;

  position: relative;
  background-color: ${({ theme }) => theme.colors.white.primary};
`

const Bg = styled(Image)`
  position: absolute !important;
  z-index: 0;

  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  mix-blend-mode: multiply;
`

const Content = styled(animated.div)`
  position: relative;
  padding: 40px 40px 40px;
  width: 43.9%;
  background: ${({ theme }) => theme.colors.white.primary};
  @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;
  }
`

type Props = {
  images: TImages
}

export const Simulator: React.FC<Props> = ({ images }) => {
  const [visible, setVisible] = React.useState(false)

  const contentStyles = useSpring({
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateX(0)' : 'translateX(-60px)',
  })

  const imageStyles = useSpring({
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    opacity: visible ? 1 : 0,
    transform: visible ? 'translateX(0)' : 'translateX(100px)',
    mixBlendMode: 'multiply',
  })

  const handler = (active: boolean) => {
    if (active) {
      setVisible(true)
    }
  }

  return (
    <VisibilitySensor onChange={handler} partialVisibility scrollDelay={2000}>
      <Container>
        <animated.div style={imageStyles}>
          <Bg fluid={images['simulator']} />
        </animated.div>
        <Wrapper>
          <Content style={contentStyles}>
            <Header size="h2">Симулятор системного анализа</Header>
            <HBox height={24} />
            <Body>
              Мы разработали «Симулятор системного анализа», который позволяет
              студентам изучать теорию, выполнять практические задачи на основе
              реальных  кейсов. Мы оцифровали образовательные процессы, ранее
              доступные только на наших оффлайн-стажировках, и предоставили
              студентам практический опыт в IT-сфере без необходимости посещать
              наш офис.
            </Body>
            <HBox height={16} />
            <Body>
              Десятки пользователей смогли пройти обучение и получить
              практический опыт, компетенции и работу в IT-индустрии.
            </Body>
            <HBox height={16} />
            <Body weight="medium">
              <a href="https://simulator.kode.ru/" target="_blank">
                Подробнее о программе →
              </a>
            </Body>
          </Content>
        </Wrapper>
      </Container>
    </VisibilitySensor>
  )
}
